<template>
  <v-dialog v-model="dialog" persistent width="700">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9>
          <v-icon>undo</v-icon> Volver al estado inicial de reprogramación
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close(false)">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <!-- Cuerpo del formulario -->
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-card-text class="py-0 px-3">
          <v-container grid-list-md style="min-width: 100%;" class="p-0">
            <v-layout wrap row>
              <v-flex xs12>
                <v-text-field
                  class="text-field-reducido-border"
                  type="text"
                  v-model="form.motivo"
                  label="Motivo"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                />
              </v-flex>
              <v-flex xs12 v-if="(form.id_estado = 65)">
                <v-select
                  :items="l_estado_vacacion"
                  :item-value="val => parseInt(val.periodo)"
                  :item-text="
                    val =>
                      `Periodo ${val.periodo} (${val.gestion_desde}-${val.gestion_hasta}) - Dias saldo: ${val.dias_restantes}`
                  "
                  label="Periodo a devolver el saldo"
                  v-model="form.periodo"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                ></v-select
              ></v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="close(false)">
            <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            color="rgba(14, 187, 178, 0.35)"
            :loading="loading"
            @click="save()"
          >
            <v-icon dark>check</v-icon>GUARDAR
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  components: {},
  // Variables iniciales
  data() {
    return {
      dialog: false,
      form: {},
      valid: false,
      loading: false,
      l_estado_vacacion: [],
      user: this.$storage.get("user")
    };
  },
  async mounted() {
    this.$bus.$on("openDialogVolverEstadoInicialReprogramacion", async item => {
      this.form = item;
      await this.cargarPeriodosVacacion(this.form.id_persona);
      this.dialog = true;
    });
  },
  methods: {
    // Metodo para cargar los periodos dispnibles de la persona
    async cargarPeriodosVacacion(id_persona) {
      let res = await this.$service.graphql({
        query: `
          query{
            estadoVacacions(id_persona: ${id_persona}){
              rows{
                id
                id_estado
                id_persona
                periodo
                gestion_desde
                gestion_hasta
                dias_restantes
              }
            }
          }
        `
      });
      this.l_estado_vacacion = res.estadoVacacions.rows;
    },
    async save() {
      try {
        if (this.$refs.form.validate()) {
          this.$confirm(
            "¿Está seguro de volver a estado inicial la vacación seleccionada?",
            async () => {
              this.loading = true;
              var query = `select vacaciones.fn_restablece_vacacion_estado_inicial(${
                this.form.id_vacacion_programada
              }, ${this.user.id}, '${this.form.motivo}',${
                this.form.periodo ? this.form.periodo : null
              })`;
              // Ejecutamos la query
              let res = await this.$service.graphql({
                query: `query{
                  runQuery(consulta:"${query}"){
                      respuesta
                    }
                  }
                `
              });
              let rpta = res.runQuery.respuesta[0].fn_restablece_vacacion_estado_inicial.split(
                "|"
              );
              if (rpta[0] == "1") {
                this.$message.success();
                this.close();
              } else {
                this.$message.info(rpta[1]);
              }
              this.loading = false;
            }
          );
        }
      } catch (error) {
        console.log(error);
      }
    },
    close() {
      this.form = {};
      this.dialog = false;
      this.$bus.$emit("closeDialogVolverEstadoInicialReprogramacion");
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/vacacion_rrhh/dialogs/VolverEstadoInicialReprogramacion.vue